import { Component, ChangeDetectorRef, inject } from '@angular/core';
import {
  ReactiveComponent,
  AssetService,
  SelectItem,
  SpinnerV2Service,
  NotificationsV2Module,
  ChipV2Module,
  SelectV2Module,
  InputV2Module,
  SpinnerV2Module,
  TileV2Module,
  ServiceErrorV2Component,
  ModalService,
} from '@schenck/rotec-components';
import { TileViewService } from 'src/services';
import { map } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';
import { ChooseMachineTaskOptionModalComponent } from '../../machine-tasks/choose-machine-task-option-modal/choose-machine-task-option-modal.component';
import { ChooseToolingTaskOptionModalComponent } from '../../tooling-tasks/choose-tooling-task-option-modal/choose-tooling-task-option-modal.component';
import { TranslateService, TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { MachineTileComponent } from '../tile/machine-tile/machine-tile.component';
import { ToolingTileComponent } from '../tile/tooling-tile/tooling-tile.component';

@Component({
  selector: 'ma-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.less'],
  imports: [
    NotificationsV2Module,
    TranslatePipe,
    TranslateDirective,
    ChipV2Module,
    SelectV2Module,
    InputV2Module,
    SpinnerV2Module,
    MachineTileComponent,
    ToolingTileComponent,
    TileV2Module,
    AsyncPipe,
    ServiceErrorV2Component,
  ],
})
export class OverviewComponent extends ReactiveComponent {
  private readonly translate = inject(TranslateService);
  private readonly assetService = inject(AssetService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly modalService = inject(ModalService);
  private readonly loadingService = inject(SpinnerV2Service);
  public tileViewService = inject(TileViewService);

  requestSuccesMessageIsVisible: boolean;
  searchText = '';

  plants$: Observable<SelectItem[]> = this.tileViewService.selectedGroup$.pipe(
    map((selectedGroup) => {
      const _plants = this.assetService
        .plantsByMachineGroupId(selectedGroup)
        .map(({ name, id }) => ({ name, value: id }));
      return [{ name: this.translate.instant('All Plants'), value: '' }, ..._plants];
    })
  );

  groups$: Observable<SelectItem[]> = this.tileViewService.selectedPlant$.pipe(
    map((selectedPlant) => {
      const _groups = this.assetService
        .machineGroupsByPlantId(selectedPlant)
        .map(({ name, id }) => ({ name, value: id }));
      return [{ name: this.translate.instant('All Groups'), value: '' }, ..._groups];
    })
  );

  loading$ = this.loadingService.state$.pipe(map((state) => state['overview']));

  state = this.connect(
    {
      tiles: this.tileViewService.tiles$,
      tileViewState: this.tileViewService.state$,
      plants: this.plants$,
      groups: this.groups$,
      selectedPlant: combineLatest([this.plants$, this.tileViewService.selectedPlant$]).pipe(
        map(([plants, selectedPlant]) => plants.find((plant) => plant.value === selectedPlant))
      ),
      selectedGroup: combineLatest([this.groups$, this.tileViewService.selectedGroup$]).pipe(
        map(([groups, selectedGroup]) => groups.find((group) => group.value === selectedGroup))
      ),
    },
    this.cdr
  );

  constructor() {
    super();
    this.filterForPlant({ name: '', value: '' });
    this.filterForGroup({ name: '', value: '' });
  }

  search(value: string) {
    this.tileViewService.filter(value);
    this.searchText = value;
  }

  clearSearch() {
    this.search('');
  }

  filterForPlant(plant: SelectItem) {
    this.tileViewService.filterForPlant(plant.value.toString());
  }

  filterForGroup(group: SelectItem) {
    this.tileViewService.filterForGroup(group.value.toString());
  }

  createMachineTask() {
    this.modalService
      .open(ChooseMachineTaskOptionModalComponent)
      .events$.subscribe((isVisible: boolean) => {
        this.requestSuccesMessageIsVisible = isVisible;
        this.cdr.markForCheck();
      });
  }

  createToolingTask() {
    this.modalService
      .open(ChooseToolingTaskOptionModalComponent)
      .events$.subscribe((isVisible: boolean) => {
        this.requestSuccesMessageIsVisible = isVisible;
        this.cdr.markForCheck();
      });
  }
}
